import React from 'react';
import useConsumeLtiDeepLinkReturn from './useConsumeLtiDeepLinkReturn';

/** Mount on Assignments surfaces to complete orphan top-level DL returns. */
export const LtiDeepLinkReturnListener = ({
  onCreated,
}: {
  onCreated?: () => void;
}) => {
  useConsumeLtiDeepLinkReturn({ onCreated });
  return null;
};

export default LtiDeepLinkReturnListener;
